module.exports = __webpack_public_path__ + "img/chalk_13.8adb7ba1.png";